/**
 * Created by neo on 21.12.20.
 */
import { makeAutoObservable, toJS } from 'mobx';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { Audited, createAuditedFields } from '../Audited';

// Observable model type (extends JSON + adds app-specific computed/methods)
export type AthleteConfiguration = Audited & {
  data: Record<string, any>;
  readonly language: string;
  save(): Promise<AthleteConfiguration>;
};

// Factory function
export function createAthleteConfiguration(json?: Partial<AthleteConfiguration>): AthleteConfiguration {
  const audited = createAuditedFields(json);

  return makeAutoObservable({
    ...audited,
    data: json?.data ?? {},

    get language(): string {
      if (this.data.locales && this.data.locales.length > 0) {
        return this.data.locales[0].languageCode ?? 'de';
      }
      return 'de';
    },

    save(): Promise<AthleteConfiguration> {
      return HttpBackend.post(`/athlete/configuration`, this)
        .then(() => this)
        .catch(() => this);
    },
  });
}

// Static API methods
export const AthleteConfigurationApi = {
  get(athleteId?: string): Promise<AthleteConfiguration> {
    return HttpBackend.get(`/athlete/configuration`, { athleteId })
      .then((res) => createAthleteConfiguration(res))
      .catch(() => createAthleteConfiguration());
  },
};
